import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "grain" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "nav-logo" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Villa Proistakis",
      src: "/logo.png"
    })
  ])
], -1)
const _hoisted_3 = { class: "nav-links desk" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://proistakisvillas.reserve-online.net",
  class: "nav-book",
  target: "_blank",
  rel: "noopener"
}, "Book a stay", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "mobile-nav-top" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/logo.png",
  alt: "Villa Proistakis"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "mobile-nav-links" }
const _hoisted_16 = { class: "mobile-nav-bottom" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Ierapetra · Crete · Greece", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "site-footer"
}
const _hoisted_20 = { class: "footer-top" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "footer-brand" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Villa Proistakis",
    src: "/logo.png"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "Private luxury villas on the southern coast of Crete, Greece.")
], -1)
const _hoisted_22 = { class: "footer-cols" }
const _hoisted_23 = { class: "footer-col" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "footer-label" }, "Pages", -1)
const _hoisted_25 = { class: "footer-col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "footer-label" }, "Contact", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Ierapetra, Lasithi, Crete", -1)
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "footer-col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "footer-label" }, "Follow", -1)
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "footer-bottom" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "All rights reserved", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("nav", {
      id: "navbar",
      class: _normalizeClass({ scrolled: _ctx.isScrolled })
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/our-villas" }, {
          default: _withCtx(() => [
            _createTextVNode("Our Villas")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/discover" }, {
          default: _withCtx(() => [
            _createTextVNode("Discover")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/contact" }, {
          default: _withCtx(() => [
            _createTextVNode("Contact")
          ]),
          _: 1
        }),
        _hoisted_4
      ]),
      _withDirectives(_createElementVNode("button", {
        class: "mobile-toggle",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNav && _ctx.openNav(...args))),
        "aria-label": "Open menu"
      }, _hoisted_8, 512), [
        [_vShow, !_ctx.navOpen]
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-nav", { open: _ctx.navOpen }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          href: "/",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNav && _ctx.openNav(...args)))
        }, _hoisted_11),
        _createElementVNode("button", {
          class: "mobile-close",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openNav && _ctx.openNav(...args))),
          "aria-label": "Close menu"
        }, _hoisted_14)
      ]),
      _createElementVNode("nav", _hoisted_15, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: _ctx.openNav
        }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/our-villas",
          onClick: _ctx.openNav
        }, {
          default: _withCtx(() => [
            _createTextVNode("Our Villas")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/discover",
          onClick: _ctx.openNav
        }, {
          default: _withCtx(() => [
            _createTextVNode("Discover")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/contact",
          onClick: _ctx.openNav
        }, {
          default: _withCtx(() => [
            _createTextVNode("Contact")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("a", {
          href: "https://proistakisvillas.reserve-online.net",
          class: "btn btn-gold",
          target: "_blank",
          rel: "noopener",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openNav && _ctx.openNav(...args)))
        }, "Book a stay"),
        _hoisted_17
      ])
    ], 2),
    (!_ctx.navOpen)
      ? (_openBlock(), _createElementBlock("main", _hoisted_18, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "page",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: _ctx.$route.path
                  }))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.navOpen)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Home")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/our-villas" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Our Villas")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/discover" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Discover")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/contact" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Contact")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _hoisted_27,
                _createElementVNode("a", {
                  href: 'tel:' + _ctx.info.telephone
                }, _toDisplayString(_ctx.info.telephone), 9, _hoisted_28),
                _createElementVNode("a", {
                  href: 'mailto:' + _ctx.info.email
                }, _toDisplayString(_ctx.info.email), 9, _hoisted_29)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("a", {
                  href: _ctx.info.social.instagram,
                  target: "_blank",
                  rel: "noopener"
                }, "Instagram", 8, _hoisted_32),
                _createElementVNode("a", {
                  href: _ctx.info.social.facebook,
                  target: "_blank",
                  rel: "noopener"
                }, "Facebook", 8, _hoisted_33),
                _createElementVNode("a", {
                  href: _ctx.info.social.tiktok,
                  target: "_blank",
                  rel: "noopener"
                }, "TikTok", 8, _hoisted_34)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()) + " Villa Proistakis", 1),
            _hoisted_36
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}